import List from './List';
import New from './New';

const Clips = { List, New };

export default Clips;
